import React, { PropTypes } from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'
import { Metrics, Fonts, Colors } from '../../Themes'
import { translate } from 'react-i18next'
import Pangea from '../../svg-icons/Pangea.js'

const Container = styled.section`
  text-align: center;
  height: calc(100vh - ${Metrics.components.navbarDefault})
  display: table;
  margin: 0 auto;

  .infos {
    display: table-cell;
    vertical-align: middle;

    svg {
      width: 146px;
      height: 164px;
    }

    .number {
      ${Fonts.style.Title}
      color: ${Colors.primary};
      font-size: 200px;
      font-weight: 400;
    }

    h1 {
      ${Fonts.style.Title}
      color: ${Colors.primary};
      font-weight: ${Fonts.weight.normal};
    }
    span {
      font-size: ${Fonts.size.medium};
    }
    button {
      margin: 0 auto;
      display: block;
      margin-top: 50px;
    }
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    .infos {
      .number {
        font-size: 160px;
      }
    }
  }
`

const Error = props => {
  const { t, router } = props
  return (
    <Container>
      <div className='infos'>
        <Pangea />
        <div className='number'>404</div>
        <h1>{t('Page Not Fount')}</h1>
        <span>{t('The page you are looking for isn’t here')}</span>
        <Button
          onClick={() => {
            router.replace('/')
          }}
          label={t('Go to Homepage')}
        />
      </div>
    </Container>
  )
}

Error.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object
}

export default translate([ 'common' ], { wait: true })(Error)



// WEBPACK FOOTER //
// ./src/pages/Error/index.js